import React from 'react';

import { Box, Button, ButtonProps, useTheme } from '@mui/material';

interface Props extends ButtonProps {
  selected?: boolean;
  icon?: string;
}

export const TreatmentOnGoingActionButton: React.FC<Props> = ({
  selected,
  icon,
  ...props
}) => {
  const { palette } = useTheme();

  return (
    <Button
      startIcon={
        icon ? <Box component="img" src={icon} mr={1} width={24} /> : null
      }
      variant="contained"
      sx={{
        color: '#FFFFFF',
        flex: 1,
        borderRadius: 0,
        boxShadow: 'none',
        marginTop: '1px',
        px: 6,
        justifyContent: 'flex-start',
        textAlign: 'left',
        backgroundColor: selected ? '#AF7D42' : palette.primary.main,
      }}
      {...props}
    />
  );
};
